// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"127":"f5155a55","146":"a09198e5","245":"514c0700","461":"0cec1a21","605":"a509a95c","754":"04e314f6","763":"129f89dd"}[chunkId] + ".chunk.js";
};